import { useState } from 'react';
import { motion } from 'framer-motion';
import Swal from 'sweetalert2';
import { userInsert } from '../api/data';
import { Link } from 'react-router-dom';
import AllData from './all-data';
import ManagedData from './managed-data';

const Add = ({ close }) => {
  const [mainTankTemp, setMainTankTemp] = useState('');
  const [reservoirTemp, setReservoirTemp] = useState('');
  const [pitcherTemp, setPitcherTemp] = useState('');
  const [heating, setHeating] = useState('');
  const [cooling, setCooling] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [temperatureQuality, setTemperatureQuality] = useState('');
  const [showAllData, setShowAllData] = useState(false); 
  const [showManagedData, setShowManagedData] = useState(false);

  const handleTempChange = (e) => {
    const temp = parseFloat(e.target.value) || '';
    setMainTankTemp(temp);

    if (temp === '') {
      setTemperatureQuality('');
    } else if (temp < 26.5) {
      setTemperatureQuality('Bad');
    } else if (temp >= 26.5 && temp <= 28.5) {
      setTemperatureQuality(temp === 27 ? 'Good' : 'Moderate');
    } else {
      setTemperatureQuality('Bad');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Retrieve user data from sessionStorage
    const user = localStorage.getItem('user');
    if (!user) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'User not authenticated',
      });
      return;
    }

    if (user === 'undefined' || user === null) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Invalid user data in session storage',
      });
      return;
    }
  
    const { username, api_key } = JSON.parse(user);
    console.log("User: ", user);
  
    const userData = {
      peltierTemp: mainTankTemp,
      reservoirTemp,
      pitcherTemp,
      heating,
      cooling,
      date,
      time,
    };
  
    try {
      const response = await userInsert(username, api_key, userData);
  
      if (response && response.status === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.message,
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload(); 
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: response ? response.message : 'Invalid response from server',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong',
      });
    }
  };

  return (
    <div className="popup-overlay">
      <motion.div
        className="popup-layer"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        <div className="title">
          Add Temperature Data
          <button onClick={close}>Close</button>
        </div>

        <form onSubmit={handleSubmit} className="form-grid">
          <label htmlFor="temperature_quality">
            <span>Temperature Quality</span><br />
            <select id="temperature_quality" name="temperature_quality" value={temperatureQuality} readOnly>
              <option value="">Auto-selected</option>
              <option value="Good">Good</option>
              <option value="Moderate">Moderate</option>
              <option value="Bad">Bad</option>
            </select>
          </label>

          <label htmlFor="main_tank_temperature">
            <span>Main Tank Temperature</span><br />
            <input
              type="number"
              step="0.1"
              id="main_tank_temperature"
              name="main_tank_temperature"
              value={mainTankTemp}
              onChange={handleTempChange}
              required
            />
          </label>

          <label htmlFor="reservoir_temperature">
            <span>Reservoir Temperature</span><br />
            <input
              type="number"
              step="0.1"
              id="reservoir_temperature"
              name="reservoir_temperature"
              value={reservoirTemp}
              onChange={(e) => setReservoirTemp(e.target.value)}
              required
            />
          </label>

          <label htmlFor="pitcher_temperature">
            <span>Pitcher Temperature</span><br />
            <input
              type="number"
              step="0.1"
              id="pitcher_temperature"
              name="pitcher_temperature"
              value={pitcherTemp}
              onChange={(e) => setPitcherTemp(e.target.value)}
              required
            />
          </label>

          <label htmlFor="heating">
            <span>Heating</span><br />
            <select id="heating" name="heating" value={heating} onChange={(e) => setHeating(e.target.value)}>
              <option value="" disabled>Select heating</option>
              <option value="0">Off</option>
              <option value="1">On</option>
            </select>
          </label>

          <label htmlFor="cooling">
            <span>Cooling</span><br />
            <select id="cooling" name="cooling" value={cooling} onChange={(e) => setCooling(e.target.value)}>
              <option value="" disabled>Select cooling</option>
              <option value="0">Off</option>
              <option value="1">On</option>
            </select>
          </label>

          <label htmlFor="date">
            <span>Date</span><br />
            <input type="date" id="date" name="date" value={date} onChange={(e) => setDate(e.target.value)} required />
          </label>

          <label htmlFor="time">
            <span>Time</span><br />
            <input type="time" id="time" name="time" value={time} onChange={(e) => setTime(e.target.value)} required />
          </label>

          <div className="form-submission">
            <button type="submit">Submit</button>

            <div className='views'>
              <Link onClick={() => setShowAllData(true)}>View all data</Link>
              <Link onClick={() => { setShowManagedData(true); setShowAllData(false); }}>View my managed data</Link>
            </div>
          </div>
        </form>
      </motion.div>

      {showAllData && <AllData close={() => setShowAllData(false)} />} 
      {showManagedData && <ManagedData close={() => setShowManagedData(false)} />}
    </div>
  );
};

export default Add;